import VStarYoga1 from "../images/VStarYoga1.JPG"
import VStarYoga3 from "../images/VStarYoga3.JPG"
import VStarYoga4 from "../images/VStarYoga4.JPG"

function ClassesHome() {
  return (
    <section className="ftco-section bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-3 d-flex align-items-stretch">
            <div className="offer-deal text-center">
              <a href="/classes">
                <div
                  className="img"
                  style={{
                    backgroundImage: `url(${VStarYoga1})`,
                  }}
                ></div>
              </a>
              <div className="text mt-4">
                <h3 className="mb-4">Introductory Yoga</h3>
                <p className="mb-5">
                  Yoga is for everyone. We love to empower people of all
                  abilities to explore the spirit-mind-body connection through
                  practice that makes the most sense for them. Book a beginners
                  class or private session with us to start your journey towards
                  a more mindful and fulfilling life!
                </p>
                <p>
                  <a href="/contact" className="btn btn-white px-4 py-3">
                    {' '}
                    Book a class{' '}
                    <span className="ion-ios-arrow-round-forward"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-stretch">
            <div className="offer-deal text-center">
              <a href="/classes">
                <div
                  className="img"
                  style={{
                    backgroundImage: `url(${VStarYoga3})`,
                  }}
                ></div>
              </a>
              <div className="text mt-4">
                <h3 className="mb-4">Moderate Yoga</h3>
                <p className="mb-5">
                  This class will help those with some yoga experience deepen
                  their practice in a supportive environment. We to explore new
                  postures, breath techniques, and more prolonged meditation to
                  encourage growth and expansion.
                </p>
                <p>
                  <a href="/classes" className="btn btn-white px-4 py-3">
                    {' '}
                    Book a class{' '}
                    <span className="ion-ios-arrow-round-forward"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-stretch">
            <div className="offer-deal text-center">
              <a href="/classes">
                <div
                  className="img"
                  style={{
                    backgroundImage: `url(${VStarYoga4})`,
                  }}
                ></div>
              </a>
              <div className="text mt-4">
                <h3 className="mb-4">Vigorous Flow</h3>
                <p className="mb-5">
                  This class is best for yogis who have been practicing for some
                  time and want to challenge themselves to build strength,
                  power, and endurance. All of our classes emphasize consistent
                  attention to mindfulness, breath awareness, and integration
                  throughout as yoga is the practice of uniting body, mind, and
                  spirit.
                </p>
                <p>
                  <a href="/contact" className="btn btn-white px-4 py-3">
                    {' '}
                    Book a class{' '}
                    <span className="ion-ios-arrow-round-forward"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-3 d-flex align-items-stretch">
            <div className="offer-deal text-center">
              <a href="/classes">
                <div
                  className="img"
                  style={{
                    backgroundImage:
                      'url(https://images.unsplash.com/photo-1505079403222-b5bbf1484f19?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2734&q=80)',
                  }}
                ></div>
              </a>
              <div className="text mt-4">
                <h3 className="mb-4">Meditation</h3>
                <p className="mb-5">
                  All yoga classes place a strong emphasis on mindfulness with
                  meditations at both the open and close of each class. However,
                  for those who would like to deepen their meditation practice,
                  inquire about our guided meditation sessions. We will meet you
                  wherever you are in your practice. We want to make meditation
                  accessible to all and a joy to explore.
                </p>
                <p>
                  <a href="/contact" className="btn btn-white px-4 py-3">
                    {' '}
                    Book a class{' '}
                    <span className="ion-ios-arrow-round-forward"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClassesHome
